import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import BrandsSection from '@/components/feature/BrandsSection';
import ServicesSection from '@/components/feature/ServicesSection';
import EmergencySection from '@/components/feature/EmergencySection';
import MaintenanceSection from '@/components/feature/MaintenanceSection';
import BoilerTypesSection from '@/components/feature/BoilerTypesSection';
import WhyUsSection from '@/components/feature/WhyUsSection';
import FaqSection from '@/components/feature/FaqSection';
import ContactSection from '@/components/feature/ContactSection';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HomeSeo from '@/components/seo/HomeSeo';
import { getHomeSeo } from '@/seo/homeRoutesMeta';

export default function Home() {
  const { pathname } = useLocation();
  const seo = getHomeSeo(pathname);

  useLayoutEffect(() => {
    const id = seo.scrollSectionId;
    if (!id) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [pathname, seo.scrollSectionId]);

  return (
    <>
      <HomeSeo pathname={pathname} />
      <main className="min-h-screen bg-white">
        <Navbar />
        <HeroSection />
        <ServicesSection />
        <EmergencySection />
        <MaintenanceSection />
        <BoilerTypesSection />
        <WhyUsSection />
        <BrandsSection />
        <FaqSection />
        <ContactSection />
        <Footer />
        <WhatsAppButton />
      </main>
    </>
  );
}
